import { __assign, __rest } from "tslib";
import React from "react";
import Svg from "./Svg";

var SvgLargeClockAlt = function SvgLargeClockAlt(_a) {
  var _b = _a.size,
      size = _b === void 0 ? 24 : _b,
      props = __rest(_a, ["size"]);

  return React.createElement(Svg, __assign({
    fill: "currentColor",
    viewBox: "0 0 69 69",
    size: size
  }, props), React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.75 34.03c0-14.138 11.462-25.6 25.6-25.6 14.132.017 25.584 11.468 25.6 25.6 0 14.139-11.461 25.6-25.6 25.6-14.138 0-25.6-11.462-25.6-25.6zm4.267 0c0 11.782 9.551 21.333 21.333 21.333 11.777-.013 21.32-9.556 21.334-21.333 0-11.782-9.551-21.333-21.334-21.333-11.782 0-21.333 9.551-21.333 21.333z",
    clipRule: "evenodd"
  }), React.createElement("path", {
    fill: "currentColor",
    d: "M45.303 42.158l-9.886-9.065V22.297a2.133 2.133 0 00-4.267 0V34.03c0 .599.25 1.17.692 1.574L42.42 45.3a2.155 2.155 0 003.014-.13 2.133 2.133 0 00-.132-3.012z"
  }));
};

export default SvgLargeClockAlt;